export const styles = {
  container: { height: '88vh', overflow: 'scroll', padding: '20px' },
  titleContainer: { width: 'fitContent', marginBottom: '55px' },
  titleWrapper: {
    width: '90%',
    textAlign: 'left',
    margin: 'auto',
    fontSize: '1.5rem',
    fontWeight: '500',
    lineHeight: '1.6',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filtersWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '90%',
    margin: 'auto',
    gap: '12px',
  },
  filtersContainer: { display: 'flex', marginRight: 'auto', gap: '15px' },
  tableContainer: { width: '90%', margin: 'auto' },
  heading: { textAlign: 'left', paddingTop: '25px', width: '90%', margin: 'auto' },
  noDataContainer: { display: 'flex', justifyContent: 'center', height: '400px' },
  toggleButton: (isActive) => ({
    background: isActive ? 'black' : '#fafafa',
    color: isActive ? 'white' : 'black',
    textTransform: 'capitalize',
    borderColor: 'black',
    height: '40px',
  }),
};
